const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const

function formatUtcDay(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (!Number.isFinite(date.getTime())) return null
  const day = date.getUTCDate()
  const month = MONTHS[date.getUTCMonth()]
  const year = date.getUTCFullYear()
  return `${day} ${month} ${year}`
}

/** Figma duration range — e.g. `23 Sep 2026 - 30 Nov 2026`. */
export function formatCampaignDurationRange(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
): string {
  const start = formatUtcDay(startDate)
  const end = formatUtcDay(endDate)
  if (!start && !end) return '—'
  if (!start) return end ?? '—'
  if (!end) return start
  return `${start} - ${end}`
}

export function isoToDateOnlyUtc(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (!Number.isFinite(date.getTime())) return ''
  const y = date.getUTCFullYear()
  const m = String(date.getUTCMonth() + 1).padStart(2, '0')
  const d = String(date.getUTCDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}
